import React from 'react';
import { useState, useEffect } from 'react';

import SeamlessScene from '../components/common/SeamlessScene';
import './home.css'
import './../animations.css'

import logodecor2 from '../assets/decor.svg'
import splashimg from '../assets/sec2img.png'


import herologo from '../assets/herologo.svg'

import { supabase } from '../supabase';
import FatimaHand from '../components/common/fatimahand';
import Button from '../components/common/button';
const Splash = () => {
    return ( <>
    <main className='splashMain'>
    <div className="splashAnim">
        <div className="handCont">
        <FatimaHand />
    </div>
    <div>
        <div className="logoCont">
            <img className='scaleIn3' src={herologo} alt="Egycraft ايجي كرافت" />
            <img className='logodecor2 scaleIn4' src={logodecor2} alt="" />
        </div>
    </div>
    </div>
    <Button
        cta="Get started"
        link="/onboarding"
        style1="blue size1 splashBtn"
        />
    </main>
<div className="splashImg">
    <img src={splashimg} alt="" />
    
    </div>    

    </> );
}
 
export default Splash;